<template>
  <div class="st-forgot-password">
    <span
      class="st-forgot-password__text"
      tabindex="0"
      @click="forgotPasswordModalOpen = true"
      role="button"
    >
      Glömt lösenord?
      <chevron-right />
    </span>
    <forgot-password-modal
      :open="forgotPasswordModalOpen"
      :close="() => (forgotPasswordModalOpen = false)"
      :success="(resetType) => handleForgotPasswordModalChoice(resetType)"
    />
    <reset-password-success-modal
      v-if="resetPasswordSuccessOpen"
      :close="() => (resetPasswordSuccessOpen = false)"
      :open="resetPasswordSuccessOpen"
    />
    <reset-password-sms-modal
      v-if="resetPasswordSmsModalOpen"
      :close="
        (isAutomaticallyClosed) =>
          handleResetPasswordSmsModalCloseAction(isAutomaticallyClosed)
      "
      :open="resetPasswordSmsModalOpen"
    />
  </div>
</template>

<script>
import ChevronRight from "../icons/ChevronRight";
import ForgotPasswordModal from "./ForgotPasswordModal";
import ResetPasswordSuccessModal from "./ResetPasswordSuccessModal";
import ResetPasswordSmsModal from "./ResetPasswordSmsModal";

export default {
  name: "st-forgot-password",
  components: {
    ChevronRight,
    ForgotPasswordModal,
    ResetPasswordSuccessModal,
    ResetPasswordSmsModal,
  },
  data() {
    return {
      forgotPasswordModalOpen: false,
      resetPasswordSuccessOpen: false,
      resetPasswordSmsModalOpen: false,
    };
  },
  methods: {
    handleForgotPasswordModalChoice(resetType) {
      if (resetType === "email") this.resetPasswordSuccessOpen = true;
      else this.resetPasswordSmsModalOpen = true;
    },
    handleResetPasswordSmsModalCloseAction(isAutomaticallyClosed) {
      if (isAutomaticallyClosed) {
        this.$emit("close-login-modal");
      }
      this.resetPasswordSmsModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";

.st-forgot-password {
  &__text {
    margin: rem-calc(20) 0;
    padding: rem-calc(10) 0;
    font-family: $source-sans-pro;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: rem-calc(14);
    cursor: pointer;
    font-weight: $semi-bold;
    text-decoration: underline;
    &:focus {
      outline: none;
      border: $border-width--thin solid $dark-grey;
      padding: rem-calc(12);
      border-radius: $border-radius;
    }
  }
}
</style>
